import React from 'react';
import {Query} from '../../utils';
import {Page, ListGroup, Row, Container, Button, Table, Form, Spinner} from '../../components';
import DataTable from './data-table.js';
import sprintf from 'yow/sprintf';




export default class extends React.Component {


    constructor(props) {
        super(props);
        this.state = {};
        this.state.loading = true;
        this.state.result = 'OK';
        this.state.stocks = null;
        this.state.filter = '';
        this.state.helpText = '';
        this.state.selection = [];



        let columns = [
            (column) => <DataTable.Column>Kolumn {column+1}</DataTable.Column>,
            (column) => <DataTable.Column>Kolumn {column+1}</DataTable.Column>
            
        ];

        
        let row1 = [
            (row, column) => <DataTable.Cell className='align-middle'>Rad {row}</DataTable.Cell>,
            (row, column) => <DataTable.Cell className='text-left'>
                <button className='btn btn-primary btn-sm'>{row}</button>
            </DataTable.Cell>
        ];

        let row2 = [
            <DataTable.Cell>Kolumn 1</DataTable.Cell>,
            <DataTable.Cell>Kolumn 2</DataTable.Cell>,
        ];

        let row3 = [
            <DataTable.Cell>A</DataTable.Cell>,
            <DataTable.Cell>B</DataTable.Cell>,
        ];

        let rows = [
            row1, row1, row1, row1, row2, row3
        ];

        this.state.rows = rows;
        this.state.columns = columns;
        this.list = React.createRef();

    }

    async fetch() {
        try {
            let query = new Query();
            let stocks = await query.fetch('SELECT * FROM stocks LIMIT 50');

            this.setState({stocks:stocks, loading:false});
    
        }
        catch(error) {
            this.setState({result:error.message, loading:false});

        }
    }

    async componentDidMount() {
        await this.fetch();
    }




    renderTable() {



        return (
                    <div>
                        <input style={{fontSize:'90%'}} className="form-control" placeholder="Snabbfilter" ></input>
                        <DataTable>
                            <DataTable.Columns style={{fontSize:'85%', background:'none'}} columns={this.state.columns}/>
                            <DataTable.Rows rows={this.state.rows} style={{background:'none'}}/>
                        </DataTable>

                    </div>

        );
        

    }

    renderSpinner() {
        let style = {};
        style.marginLeft = 'auto';
        style.marginRight = 'auto';
        style.display = 'flex';
        style.alignItems = 'center';

        return (
            <Spinner style={style} animation="grow" />
        );
    }

    render() {


        return (
            <Page>
                {this.renderTable()}
                <Button link={-1}>
                    Tillbaka
                </Button>

            </Page>
        );

    }
}



